<template>
  <div>
    <v-form
      ref="form"
      class="mx-2"
      lazy-validation
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="localData.loanModel"
            clearable
            required
            single-line
            return-object
            :items="loans"
            label="وام*"
            item-text="title"
            item-value="id"
            :error-messages="errorMessages"
            :rules="[() => !!localData.loanModel || 'وام را انتخاب کنید']"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-money
            ref="amount"
            v-model="localData.amount"
            :label="'مبلغ (ریال)*'"
            :error-messages="errorMessages"
            :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <v-textarea
            v-model="localData.comment"
            outlined
            :error-messages="errorMessages"
            label="توضیحات"
            hint="حداکثر 1000 کاراکتر"
          />
        </v-col>
      </v-row>
      <div v-if="localData.id != '00000000-0000-0000-0000-000000000000'">
        <div class="black--text">
          وضعیت درخواست:
        </div>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            تاریخ ثبت درخواست: <br>{{ (localData.requestDate_Persian || {}).date }}
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            وضعیت: <br>{{ localData.str_Status }}
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            اولویت: <br>{{ localData.status >= 3 ? `${localData.year}/${localData.month}` : 'تعیین نشده' }}
          </v-col>
        </v-row>
        <div class="black--text mt-2">
          نظر هیئت مدیره:
        </div>
        <v-row>
          <v-col cols="12">
            {{ (localData.adminDescription || 'تاکنون هیئت مدیره نظری ثبت نکرده است.') }}
          </v-col>
        </v-row>
      </div>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="$emit('callbck',false)"
      >
        بستن
      </v-btn>
      <v-btn
        color="blue"
        dark
        @click="submit()"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import { emptyId } from '@/util/emptyId'

  export default {
    name: 'ModifyRequestView',
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        loans: [],
      }
    },
    mounted () {
      // this.prepareData()
    },
    methods: {
      submit () {
        if (!this.$refs.form.validate()) { return }

        api.post('member/userLoanRequest/' + (this.localData.id === emptyId ? 'create' : 'edit'), this.localData)
          .then(
            response => {
              toast.success('اطلاعات با موفقیت ذخیره شد.')
              this.$emit('callbck', true)
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      prepareData () {
        if (!this.data) {
          this.data = { id: emptyId }
        }
        if (!this.data.id) {
          this.data.id = emptyId
        }
        api.get('member/userLoanRequest/get/' + this.data.id, null)
          .then(
            response => {
              this.localData = response
              if (this.data.id === emptyId) Object.assign(this.localData, this.data)
            })
          .catch(err => {
            toast.error(err.message)
          })
        this.loadLoans()
      },
      loadLoans () {
        api.get('member/userLoanRequest/loanslist', null)
          .then(
            response => {
              this.loans = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
